import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatNumber, formatTRY } from "@/lib/format";

export default function ReturnDialog({ o, onClose, onDone }) {
  const [qty, setQty] = useState({});
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const left = (l) => l.qty - (l.returned_qty || 0);
  const total = o.lines.reduce((s, l) => s + (Number(qty[l.product_id]) || 0) * (l.line_net_try / l.qty) * (1 + (l.vat_rate || 20) / 100), 0);
  const submit = async (e) => {
    e.preventDefault();
    const lines = Object.entries(qty).filter(([, v]) => Number(v) > 0).map(([product_id, v]) => ({ product_id, qty: Number(v) }));
    if (!lines.length) return toast.error("İade miktarı girin");
    setBusy(true);
    try { const { data } = await api.post(`/orders/${o.id}/returns`, { lines, reason }); toast.success(`${data.return_no} oluşturuldu · Prim: ${data.prim_effect.message}`); onDone(); }
    catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="return-dialog">
        <DialogHeader><DialogTitle>Satış İadesi · {o.invoice_no || o.order_no}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <table className="erp-table text-[12px]"><thead><tr><th>SKU</th><th>Ürün</th><th className="text-right">Satılan</th><th className="text-right">İade Edilen</th><th className="text-right">İade Miktarı</th></tr></thead>
            <tbody>{o.lines.map((l) => (
              <tr key={l.product_id}><td className="font-mono">{l.sku}</td><td className="max-w-[240px] truncate">{l.name}</td><td className="text-right font-mono">{formatNumber(l.qty)}</td>
                <td className="text-right font-mono">{formatNumber(l.returned_qty || 0)}</td>
                <td className="text-right"><div className="flex justify-end gap-1"><Input type="number" min="0" max={left(l)} step="1" className="h-8 w-24" value={qty[l.product_id] || ""} disabled={left(l) <= 0}
                  onChange={(e) => setQty({ ...qty, [l.product_id]: e.target.value })} data-testid={`return-qty-${l.sku}`} />
                  <Button type="button" size="sm" variant="ghost" disabled={left(l) <= 0} onClick={() => setQty({ ...qty, [l.product_id]: left(l) })} data-testid={`return-all-${l.sku}`}>Tümü</Button></div></td>
              </tr>))}</tbody></table>
          <Input placeholder="İade nedeni (zorunlu)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="return-reason" />
          <div className="text-[12px] text-slate-600">Cari alacak (KDV dahil): <b className="font-mono" data-testid="return-total">{formatTRY(total)}</b> · Stok depoya geri girer, orijinal maliyet snapshot'ı kullanılır. Prim: dönem ödenmediyse yeniden hesaplamada düşülür; tamamen ödendiyse gelecek dönem düzeltmesi oluşur.</div>
          <DialogFooter><Button type="submit" disabled={busy || reason.trim().length < 3} className="bg-rose-600 hover:bg-rose-700" data-testid="return-submit">İadeyi Kaydet</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
